import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getVideoFormats() {
  try {
    const resp = await axios.get("/api/videoFormat/?pageSize=30");
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
